import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input } from '@angular/core';
import { Client } from '@df/core/service/client';
import { ImageModule } from '@df/module-image/image.module';
/**
 * Component that toggles images when hovered
 * Needs to be wrapped with a ratiod container
 */
@Component({
    selector: 'alt-image',
    templateUrl: './alt-image.html',
    styleUrls: ['./alt-image.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ImageModule]
})
export class AltImageComponent {
    /**
     * Default image
     */
    @Input()
    mainImage?: string;
    /**
     * Alternative image visible on hover
     */
    @Input()
    altImage?: string;
    /**
     * Alt attribute text
     */
    @Input()
    altText?: string;
    /**
     * Dependencies
     */
    constructor(private cd: ChangeDetectorRef, private client: Client) { }
    /**
     * Ever hovered
     */
    private hovered = false;
    @HostListener('mouseenter')
    onMouseEnter() {
        if (!this.hovered) {
            this.hovered = true;
            this.cd.detectChanges();
        }
    }
    /**
     * Alternative image is only printed after first time it was needed
     */
    canPrintAltImage(): boolean {
        return !this.client.isTouchy && !!(this.hovered && this.altImage);
    }
}
